const obj = {
    development: {
        equity: 6819,
        ventureDebt: 6820,
        lineOfCredit: 6811,
        pEGrowth: 6826
    },
    production: {
        equity: 6762,
        ventureDebt: 6783,
        lineOfCredit: 6795,
        pEGrowth: 6826
    }
};

export const INVESTMENT_VEHICLES = obj[process.env.NODE_ENV];